import React from 'react';

import { CheckCircleOutline, ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  capitalize,
  Grid,
} from '@mui/material';

import * as colors from 'commons/styles/colors';
import { ISTOPickItemWithSummary } from 'commons/types';

import { STOCheckSummaryPageStyle as S } from '../STOCheckSummaryPage.style';

import { STOCheckBinList } from './STOCheckBinList.component';

interface STOSkuListProps {
  stoItems: ISTOPickItemWithSummary[];
  headerText: string;
  headerIcon?: React.JSX.Element;
  headerColor?: string;
  defaultExpanded?: boolean;
}
export const STOSkuList: React.FC<STOSkuListProps> = ({
  stoItems,
  headerText,
  defaultExpanded,
  headerColor,
  headerIcon,
}) => {
  return (
    <>
      <S.Header color={headerColor || colors.PRIMARY_GREEN}>
        {headerIcon || <CheckCircleOutline />} {capitalize(headerText)}
      </S.Header>
      {stoItems.map((item, i) => {
        const qtyColor =
          item.checking_metadata.total_qty_checked === item.quantity
            ? colors.PRIMARY_GREEN
            : !item.checking_metadata.total_qty_checked
            ? colors.PRIMARY_BLACK
            : colors.PRIMARY_YELLOW;
        return (
          <Accordion
            defaultExpanded={item.pick_actual.length !== 0 && defaultExpanded}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`panel${i}-content`}
              id={`panel${i}-header`}
            >
              <Grid container style={{ fontWeight: 700 }}>
                <Grid item xs={8} data-testid={`TextSTSummarySKU-${i + 1}`}>
                  {item.sku_code}{' '}
                  <S.STONumberText>{item.sto_number}</S.STONumberText>
                </Grid>
                <Grid
                  item
                  xs={4}
                  style={{
                    textAlign: 'right',
                    verticalAlign: 'middle',
                    color: qtyColor,
                  }}
                >
                  {item.checking_metadata.total_qty_checked || 0} /{' '}
                  {item.quantity}
                </Grid>
                <Grid item xs={12} data-testid={`TextNameSummarySKU-${i + 1}`}>
                  <S.SubHeaderText>{item.name}</S.SubHeaderText>
                  <S.SubHeaderAdditionalText>
                    Box Number: {item.box_number || '-'}
                  </S.SubHeaderAdditionalText>
                  <S.SubHeaderAdditionalText>
                    Pallet: {item.pallet || '-'}
                  </S.SubHeaderAdditionalText>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid />
              <STOCheckBinList pickActual={item.pick_actual} />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};
